import React from 'react';
import { Icon } from '@chakra-ui/icons';

export const DollarIcon = ({ color = '#333131' }: { color?: string }) => {
	return (
		<Icon
			width="auto"
			height="28px"
			viewBox="0 0 20 35"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.808 29.964C7.696 29.964 5.92 29.628 4.48 28.956C3.064 28.284 1.996 27.336 1.276 26.112C0.556 24.864 0.196 23.424 0.196 21.792H2.716C2.716 22.8 2.944 23.748 3.4 24.636C3.88 25.524 4.636 26.256 5.668 26.832C6.7 27.384 8.08 27.66 9.808 27.66C12.112 27.66 13.828 27.18 14.956 26.22C16.108 25.26 16.684 24.096 16.684 22.728C16.684 21.432 16.18 20.34 15.172 19.452C14.188 18.564 12.712 18.024 10.744 17.832L8.368 17.616C6.136 17.424 4.36 16.764 3.04 15.636C1.744 14.484 1.096 12.864 1.096 10.776C1.096 9.36 1.432 8.124 2.104 7.068C2.776 6.012 3.748 5.196 5.02 4.62C6.292 4.044 7.828 3.756 9.628 3.756C11.452 3.756 13 4.08 14.272 4.728C15.568 5.376 16.552 6.288 17.224 7.464C17.896 8.64 18.232 10.02 18.232 11.604H15.676C15.676 10.644 15.46 9.744 15.028 8.904C14.62 8.064 13.972 7.38 13.084 6.852C12.22 6.324 11.068 6.06 9.628 6.06C8.332 6.06 7.24 6.276 6.352 6.708C5.464 7.116 4.792 7.68 4.336 8.4C3.904 9.096 3.688 9.888 3.688 10.776C3.688 12 4.096 13.008 4.912 13.8C5.752 14.592 6.988 15.06 8.62 15.204L10.996 15.42C13.564 15.66 15.58 16.428 17.044 17.724C18.532 18.996 19.276 20.664 19.276 22.728C19.276 24.144 18.892 25.404 18.124 26.508C17.38 27.588 16.3 28.44 14.884 29.064C13.492 29.664 11.8 29.964 9.808 29.964ZM8.584 34.644V29.388H10.996V34.644H8.584ZM8.44 5.16V0.227999H10.852V5.16H8.44Z"
				fill={color}
			/>
		</Icon>
	);
};
